import * as yup from 'yup';
import * as v from 'src/utils/form/validate';

const maxNameLength = 128;
const maxDescriptionLength = 2000;

export default function getValidationSchema() {
  const validationSchema = yup.object({
    title: v.validateName(yup, "ім'я", maxNameLength),
    url: v.validateUrl(yup),
    description: v.validateName(yup, 'опис', maxDescriptionLength, false)
  });

  return validationSchema;
}
